import React from 'react';

import { SVG } from 'types/svg';

function FlagKeto(props: SVG) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <defs>
        <path id="flagketo" d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M0 0h24v24H0z" />
        <use fill="#264653" fillRule="nonzero" xlinkHref="#flagketo" />
      </g>
    </svg>
  );
}

export default FlagKeto;
